<div class="kl-search-maprequests vl-form" v-kl-u-background-alt v-kl-u-box-padding>
    <vl-form-grid mod-stacked>
        <!-- basic search -->
        <vl-column width-l="7">
            <div v-kl-u-background-white v-kl-u-box-padding class="kl-search-maprequests__keyword-search">
                <vl-form-grid>
                    <vl-column>
                        <vl-radio v-for="field in searchFields"
                                  :key="field.key"
                                  :id="uniqueFieldId(field.key)"
                                  :value="field.key"
                                  v-model="searchData.searchField"
                                  :mod-block="isMobile"
                        >
                            {{ field.label }}
                        </vl-radio>
                    </vl-column>
                </vl-form-grid>
                <div class="vl-u-spacer vl-u-spacer--small"></div>
                <vl-input-field name="keyword" placeholder="Zoek trefwoord" autocomplete="off" v-model="searchData.keyword" mod-block/>
            </div>
        </vl-column>
        <vl-column width-l="5">
            <div v-kl-u-background-white v-kl-u-box-padding>

                <vl-column v-if="useDateMode">
                    <vl-radio v-for="field in dateModeOptions"
                              :key="field.key"
                              :id="uniqueFieldId(field.key)"
                              :value="field.key"
                              v-model="searchData.dateMode"
                              :mod-block="isMobile"
                    >
                        {{ field.label }}
                    </vl-radio>
                </vl-column>
                <vl-column v-else>
                    <vl-form-message-label>Aanvraagdatum</vl-form-message-label>
                </vl-column>

                <vl-form-grid mod-stacked>
                    <vl-column width="half" width-xs="12">
                        <label for="date-from">van</label>
                        <kl-datepicker v-model="searchData.dateFrom" :max-date="dateFromMaxDate"/>
                    </vl-column>
                    <vl-column width="half" width-xs="12">
                        <label for="date-to">tot en met</label>
                        <kl-datepicker v-model="searchData.dateTo" :min-date="dateToMinDate"/>
                    </vl-column>
                </vl-form-grid>
            </div>
        </vl-column>
        <!-- ./basic search -->

        <!-- extra-options -->
        <vl-column width-l="4" v-if="searchOptions">
            <vl-form-message-label for="search-options" v-vl-visually-hidden>Aanvrager</vl-form-message-label>
            <vl-select name="search-options" data-testid="search-options" v-model="searchData.searchOption" mod-block>
                <option :value="option.value" v-for="option in searchOptions">
                    {{ option.label }}
                </option>
                <template v-for="groupedOptions in groupedSearchOptions">
                    <optgroup :label="groupedOptions.groupName">
                        <option :value="option.key" v-for="option in groupedOptions.codeListValues" v-html="setDepth(option.order, option.label)">
                        </option>
                    </optgroup>
                </template>
            </vl-select>
        </vl-column>
        <vl-column width-l="4" v-if="!modSimple">
            <kl-locationpicker ref="locationpicker" v-model="searchData.location"/>
        </vl-column>
        <vl-column width-l="4" v-if="!modSimple && !onlyActive">
            <vl-form-message-label for="search-archive" v-vl-visually-hidden>Actief of archief</vl-form-message-label>
            <vl-select name="search-archive" data-testid="search-archive" v-model="searchData.searchArchive"
                       mod-no-placeholder mod-block>
                <option :value="option.key" v-for="option in searchArchiveOptions">
                    {{ option.label }}
                </option>
            </vl-select>
        </vl-column>
        <!-- ./extra-options -->

        <!-- tags -->
        <vl-column mod-block v-if="hasTags">
            <label for="search-tags" v-vl-visually-hidden>Zoek tags</label>
            <vl-multiselect
                name="searchTags"
                v-model="searchData.searchTags"
                :options="tags"
                mode="tags"
                placeholder="Zoek tags"
                select-label="Selecteer tag"
                tag-placeholder="Voeg nieuwe tag toe"
                noResultsText="Geen tags gevonden..."
                noOptionsText="Geen tags beschikbaar!"
            />
        </vl-column>
        <!-- ./tags -->

        <!-- operations -->
        <vl-column width-l="4" v-if="$slots.operations">
            <slot name="operations"></slot>
        </vl-column>
        <!-- ./operations -->

        <!-- zones -->
        <vl-column width-l="4" v-if="$slots.zones">
            <slot name="zones"></slot>
        </vl-column>
        <!-- ./zones -->

        <!-- move -->
        <vl-column width-l="6" v-if="$slots.movemaprequest">
            <slot name="movemaprequest"></slot>
        </vl-column>
        <!-- ./move -->

    </vl-form-grid>
</div>
